import { ReactNode } from 'react';
import { Select, SelectContent, SelectGroup, SelectLabel, SelectTrigger, SelectValue } from "../../ui/select";
import { Label } from '@/components/ui/label';

interface ISelectComponentProps {
    children?: ReactNode;
    label?: string;
    value?: string;
    placeholder?: string;
    onChange?: ((value: string) => void);
    className?: string;
}

/**
 * Componente para exibir um select customizável.
 * @param children Conteúdo do select (options)
 * @param label Rótulo do select.
 * @param value Valor selecionado no select.
 * @param placeholder Texto de placeholder no select.
 * @param onChange Função de callback para mudança de valor.
 * @param className Classe CSS adicional para o select.
 * @returns Componente de select customizável.
 */

// const SelectComponent = ({ children, label, onChange, value, placeholder, className }: ISelectComponentProps) => {
const SelectComponent = ({ children, label, onChange, value='none', placeholder, className }: ISelectComponentProps) => {
    return (
        <div className={`${className} mt-[16px]`}>
            <Label className="text-colorPrimary mb-2">{label}</Label>
            <Select onValueChange={onChange} value={value}>
                <SelectTrigger className="w-full">
                    <SelectValue placeholder={placeholder} />
                </SelectTrigger>
                <SelectContent>
                    <SelectGroup>
                        <SelectLabel>{label}</SelectLabel>
                        {children}
                    </SelectGroup>
                </SelectContent>
            </Select>
        </div>
    );
}

export { SelectComponent };